// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home.navbar{
    position: fixed;
    top:30px;
    left:0;
    width:100vw;
    height:80px;
    display:grid;
    grid-template-columns: 1fr 4fr ;
    align-items: center;
    z-index:5;
    opacity: 1;
    
    
}

.navbar-links{
    display: grid;
    grid-template-columns: 5fr 1fr;
}

.navbar:not(.home){
    position: fixed;
        top: 30px;
        left: 0;
        width: 100vw;
        height: 80px;
        display: grid;
        grid-template-columns: 1fr 4fr;
        align-items: center;
        background-color: #E42727;
        z-index: 5;
            opacity: 1;

}

.navbar.scrolled {
    background-color: #E42727;
    z-index: 5;
    opacity:1;
    /* Change to desired color after scrolling */
}


.home.navbar:hover{
    background-color: #E42727;
    z-index: 5;
        opacity: 1;

}

.home #hover-logo{
    display: none;
    cursor: pointer;
}

.home.navbar:hover #default-logo{
    display: none;
    cursor: pointer;
}

.home.navbar:hover #hover-logo{
    display: block;
    cursor: pointer;
}

.navbar:not(.home) #default-logo{
    display: none;
    cursor: pointer;

}

.navbar:not(.home) #hover-logo{
    display: block;
    cursor: pointer;
}
.navbar.scrolled #default-logo {
    display: none;
    cursor: pointer;
}
.navbar.scrolled #hover-logo {
    display: block;
    cursor: pointer;
}


.logo{
    display: flex;
    align-items: center;
    justify-content: center;
}
.logo-image{
    width:200px;
    border-radius: 10px;
   
}

.nav-links ul{
    list-style-type: none;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
    
}
.nav-links ul li{
    font-size:medium;
    font-family: 'Poppins', sans-serif;
    color:black;
    font-weight: 500;
    width:fit-content;
    
}
.navbar:not(.home) .nav-links ul li{
    color:#fff;
}


.navbar:hover .nav-links ul li{
    color:#FFf;
}

.navbar:hover .dropdown-content{
    color:black;
}

.nav-links ul li a{
    padding: 15px 10px;
    text-decoration: none;
    color:inherit;
}

.nav-links ul li a:hover{
    background-color: #F2C713;
    padding:10px 30px;
    border-radius:50px;
}
.nav-icons{
    display: flex;
    flex-direction: row;
    
    align-items: center;
    color:black;
    cursor: pointer;
    justify-content: center;
    
    
}

.fontawesome-icon{
    margin-right:30px;
}

.navbar:hover .fontawesome-icon{
    color:#fff;
}

.nav-icons span{
    background-color: #F2C713;
    padding: 2px 5px;
    width:30px;
    height:20px;
    border-radius: 50%;
    font-size: xx-small;
    border-style: solid;
    border-color: red;
    border-width: 1px;
    margin-left: -20px;
    
    
}

.fontawesome-icon{
    color:black;
    width:20px;
    height:20px;
    margin-left:5px;
    transform-style: preserve-3d;
        /* Enables 3D transformations */
    transition: transform 0.6s ease;
    transform: rotateY(0deg);
        
    
}

.navbar:not(.home) .fontawesome-icon{
    color:#fff;
}

.fontawesome-icon:hover{
    transform: rotateY(180deg);
}

.fontawesome-icon a{
    font-size: larger;
    text-decoration: none;
    color: inherit;
}

span{
    position: relative;
    top:-10px;
    font-size: small;
    color: blue;
    
}
Link{
text-decoration: none;
}

.dropdown-content{
        display: none;
        position: absolute;
        top: 100%;
       
        /* Position it directly below the dropdown trigger */
      
        background-color: #f9f9f9;
        min-width: 200px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        z-index: 1;
        transition: opacity 1s ease, visibility 1s ease;
        border-radius: 20px;
}

.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

.dropdown-content img{
    width:40px;
    height:40px;
    border-radius: 20px;
}

.dropdown-content a:hover {
    background-color: #F2C713;
}

/* Show dropdown content on hover */
.dropdown:hover .dropdown-content {
    display: block;
}

.dropdown:not(:hover) .dropdown-content {
    display: block;
    /* Keep it block so the opacity can transition */
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    /* Smooth transition */
}


.dropdown-content-login {
    display: none;
    position: absolute;
    top: 100%;
    right:30px;

    /* Position it directly below the dropdown trigger */

    background-color: #f9f9f9;
    min-width: 200px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    transition: opacity 1s ease, visibility 1s ease;
    border-radius: 20px;

}

.dropdown-content-login a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

.dropdown-content-login img {
    width: 40px;
    height: 40px;
    border-radius: 20px;
}

.dropdown-content-login a:hover {
    background-color: #F2C713;
}

/* Show dropdown content on hover */
.dropdown:hover .dropdown-content-login {
    display: block;
}

.dropdown:not(:hover) .dropdown-content-login {
    display: block;
    /* Keep it block so the opacity can transition */
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    /* Smooth transition */
}

.marquee {
    background-color: #ffcc00;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    width: 100vw;
    height: 30px;
    line-height: 30px;
    z-index: 4;
}

.marquee-content {
    display: inline-block;
    padding-left: 100%;
    /* Space to enable continuous effect */
    animation: marquee 20s linear infinite;
}

.marquee-content p {
    display: inline;
    margin: 0;
    font-family: 'Poppins', sans-serif;
    color: #E42727;
    font-weight: 400;
    letter-spacing: 1px;
}

/* Keyframes to move content continuously */
@keyframes marquee {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-100%);
    }
}

/* #007bff */
.email-avatar {
    width: 30px;
    height: 30px;
    
    /* Blue background */
    color: #e42727;
    /* White text */
    border-radius: 50%;
    /* Circle shape */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    /* Adjust as needed */
    font-weight: bold;
    text-transform: uppercase;
    /* Ensure letter is uppercase */
    cursor: pointer;
    margin-right: 10px;
}
.email-avatar img{
    width:30px;
    height:30px;
    border-radius: 50%;
    
}




@media screen and (max-width:768px){
    .home.navbar {
            position: fixed;
            top: 30px;
            left: 0;
            width: 100vw;
            height: 200px;
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 5;
            opacity: 1;
            background-color: #E42727;
    
    
        }

        .navbar-links{
            display: flex;
            flex-direction: column;
        }

        .marquee {
            background-color: #ffcc00;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            box-sizing: border-box;
            position: fixed;
            top: 0;
            width: 100vw;
            height: 30px;
            line-height: 30px;
            z-index: 4;
        }
    
        .marquee-content {
            display: inline-block;
            padding-left: 100%;
            /* Space to enable continuous effect */
            animation: marquee 20s linear infinite;
        }
    
        .marquee-content p {
            display: inline;
            margin: 0;
            font-family: 'Poppins', sans-serif;
            color: #E42727;
            font-weight: 400;
            letter-spacing: 1px;
        }
    
        /* Keyframes to move content continuously */
        @keyframes marquee {
            0% {
                transform: translateX(0);
            }
    
            100% {
                transform: translateX(-100%);
            }
        }

        
}

@media screen and (max-width:1000px){
 .nav-links ul li {
        font-size: smaller;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Navbar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,mBAAmB;IACnB,SAAS;IACT,UAAU;;;AAGd;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;QACX,SAAS;QACT,OAAO;QACP,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,yBAAyB;QACzB,UAAU;YACN,UAAU;;AAEtB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,SAAS;IACT,4CAA4C;AAChD;;;AAGA;IACI,yBAAyB;IACzB,UAAU;QACN,UAAU;;AAElB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;;AAEnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;;AAEzB;AACA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,WAAW;IACX,gBAAgB;IAChB,iBAAiB;;AAErB;AACA;IACI,UAAU;AACd;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;;IAEnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,uBAAuB;;;AAG3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;;;AAGtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,eAAe;IACf,4BAA4B;QACxB,+BAA+B;IACnC,+BAA+B;IAC/B,wBAAwB;;;AAG5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,WAAW;;AAEf;AACA;AACA,qBAAqB;AACrB;;AAEA;QACQ,aAAa;QACb,kBAAkB;QAClB,SAAS;;QAET,oDAAoD;;QAEpD,yBAAyB;QACzB,gBAAgB;QAChB,+CAA+C;QAC/C,UAAU;QACV,+CAA+C;QAC/C,mBAAmB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gDAAgD;IAChD,UAAU;IACV,kBAAkB;IAClB,mDAAmD;IACnD,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;;IAEV,oDAAoD;;IAEpD,yBAAyB;IACzB,gBAAgB;IAChB,+CAA+C;IAC/C,UAAU;IACV,+CAA+C;IAC/C,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gDAAgD;IAChD,UAAU;IACV,kBAAkB;IAClB,mDAAmD;IACnD,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,SAAS;IACT,kCAAkC;IAClC,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,2CAA2C;AAC3C;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA,YAAY;AACZ;IACI,WAAW;IACX,YAAY;;IAEZ,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;;AAEtB;;;;;AAKA;IACI;YACQ,eAAe;YACf,SAAS;YACT,OAAO;YACP,YAAY;YACZ,aAAa;YACb,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,UAAU;YACV,UAAU;YACV,yBAAyB;;;QAG7B;;QAEA;YACI,aAAa;YACb,sBAAsB;QAC1B;;QAEA;YACI,yBAAyB;YACzB,WAAW;YACX,mBAAmB;YACnB,gBAAgB;YAChB,sBAAsB;YACtB,eAAe;YACf,MAAM;YACN,YAAY;YACZ,YAAY;YACZ,iBAAiB;YACjB,UAAU;QACd;;QAEA;YACI,qBAAqB;YACrB,kBAAkB;YAClB,sCAAsC;YACtC,sCAAsC;QAC1C;;QAEA;YACI,eAAe;YACf,SAAS;YACT,kCAAkC;YAClC,cAAc;YACd,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA,2CAA2C;QAC3C;YACI;gBACI,wBAAwB;YAC5B;;YAEA;gBACI,4BAA4B;YAChC;QACJ;;;AAGR;;AAEA;CACC;QACO,kBAAkB;IACtB;AACJ","sourcesContent":[".home.navbar{\n    position: fixed;\n    top:30px;\n    left:0;\n    width:100vw;\n    height:80px;\n    display:grid;\n    grid-template-columns: 1fr 4fr ;\n    align-items: center;\n    z-index:5;\n    opacity: 1;\n    \n    \n}\n\n.navbar-links{\n    display: grid;\n    grid-template-columns: 5fr 1fr;\n}\n\n.navbar:not(.home){\n    position: fixed;\n        top: 30px;\n        left: 0;\n        width: 100vw;\n        height: 80px;\n        display: grid;\n        grid-template-columns: 1fr 4fr;\n        align-items: center;\n        background-color: #E42727;\n        z-index: 5;\n            opacity: 1;\n\n}\n\n.navbar.scrolled {\n    background-color: #E42727;\n    z-index: 5;\n    opacity:1;\n    /* Change to desired color after scrolling */\n}\n\n\n.home.navbar:hover{\n    background-color: #E42727;\n    z-index: 5;\n        opacity: 1;\n\n}\n\n.home #hover-logo{\n    display: none;\n    cursor: pointer;\n}\n\n.home.navbar:hover #default-logo{\n    display: none;\n    cursor: pointer;\n}\n\n.home.navbar:hover #hover-logo{\n    display: block;\n    cursor: pointer;\n}\n\n.navbar:not(.home) #default-logo{\n    display: none;\n    cursor: pointer;\n\n}\n\n.navbar:not(.home) #hover-logo{\n    display: block;\n    cursor: pointer;\n}\n.navbar.scrolled #default-logo {\n    display: none;\n    cursor: pointer;\n}\n.navbar.scrolled #hover-logo {\n    display: block;\n    cursor: pointer;\n}\n\n\n.logo{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.logo-image{\n    width:200px;\n    border-radius: 10px;\n   \n}\n\n.nav-links ul{\n    list-style-type: none;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    text-decoration: none;\n    \n}\n.nav-links ul li{\n    font-size:medium;\n    font-family: 'Poppins', sans-serif;\n    color:black;\n    font-weight: 500;\n    width:fit-content;\n    \n}\n.navbar:not(.home) .nav-links ul li{\n    color:#fff;\n}\n\n\n.navbar:hover .nav-links ul li{\n    color:#FFf;\n}\n\n.navbar:hover .dropdown-content{\n    color:black;\n}\n\n.nav-links ul li a{\n    padding: 15px 10px;\n    text-decoration: none;\n    color:inherit;\n}\n\n.nav-links ul li a:hover{\n    background-color: #F2C713;\n    padding:10px 30px;\n    border-radius:50px;\n}\n.nav-icons{\n    display: flex;\n    flex-direction: row;\n    \n    align-items: center;\n    color:black;\n    cursor: pointer;\n    justify-content: center;\n    \n    \n}\n\n.fontawesome-icon{\n    margin-right:30px;\n}\n\n.navbar:hover .fontawesome-icon{\n    color:#fff;\n}\n\n.nav-icons span{\n    background-color: #F2C713;\n    padding: 2px 5px;\n    width:30px;\n    height:20px;\n    border-radius: 50%;\n    font-size: xx-small;\n    border-style: solid;\n    border-color: red;\n    border-width: 1px;\n    margin-left: -20px;\n    \n    \n}\n\n.fontawesome-icon{\n    color:black;\n    width:20px;\n    height:20px;\n    margin-left:5px;\n    transform-style: preserve-3d;\n        /* Enables 3D transformations */\n    transition: transform 0.6s ease;\n    transform: rotateY(0deg);\n        \n    \n}\n\n.navbar:not(.home) .fontawesome-icon{\n    color:#fff;\n}\n\n.fontawesome-icon:hover{\n    transform: rotateY(180deg);\n}\n\n.fontawesome-icon a{\n    font-size: larger;\n    text-decoration: none;\n    color: inherit;\n}\n\nspan{\n    position: relative;\n    top:-10px;\n    font-size: small;\n    color: blue;\n    \n}\nLink{\ntext-decoration: none;\n}\n\n.dropdown-content{\n        display: none;\n        position: absolute;\n        top: 100%;\n       \n        /* Position it directly below the dropdown trigger */\n      \n        background-color: #f9f9f9;\n        min-width: 200px;\n        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n        z-index: 1;\n        transition: opacity 1s ease, visibility 1s ease;\n        border-radius: 20px;\n}\n\n.dropdown-content a {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n.dropdown-content img{\n    width:40px;\n    height:40px;\n    border-radius: 20px;\n}\n\n.dropdown-content a:hover {\n    background-color: #F2C713;\n}\n\n/* Show dropdown content on hover */\n.dropdown:hover .dropdown-content {\n    display: block;\n}\n\n.dropdown:not(:hover) .dropdown-content {\n    display: block;\n    /* Keep it block so the opacity can transition */\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n    /* Smooth transition */\n}\n\n\n.dropdown-content-login {\n    display: none;\n    position: absolute;\n    top: 100%;\n    right:30px;\n\n    /* Position it directly below the dropdown trigger */\n\n    background-color: #f9f9f9;\n    min-width: 200px;\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n    z-index: 1;\n    transition: opacity 1s ease, visibility 1s ease;\n    border-radius: 20px;\n\n}\n\n.dropdown-content-login a {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n.dropdown-content-login img {\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n}\n\n.dropdown-content-login a:hover {\n    background-color: #F2C713;\n}\n\n/* Show dropdown content on hover */\n.dropdown:hover .dropdown-content-login {\n    display: block;\n}\n\n.dropdown:not(:hover) .dropdown-content-login {\n    display: block;\n    /* Keep it block so the opacity can transition */\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n    /* Smooth transition */\n}\n\n.marquee {\n    background-color: #ffcc00;\n    color: #000;\n    white-space: nowrap;\n    overflow: hidden;\n    box-sizing: border-box;\n    position: fixed;\n    top: 0;\n    width: 100vw;\n    height: 30px;\n    line-height: 30px;\n    z-index: 4;\n}\n\n.marquee-content {\n    display: inline-block;\n    padding-left: 100%;\n    /* Space to enable continuous effect */\n    animation: marquee 20s linear infinite;\n}\n\n.marquee-content p {\n    display: inline;\n    margin: 0;\n    font-family: 'Poppins', sans-serif;\n    color: #E42727;\n    font-weight: 400;\n    letter-spacing: 1px;\n}\n\n/* Keyframes to move content continuously */\n@keyframes marquee {\n    0% {\n        transform: translateX(0);\n    }\n\n    100% {\n        transform: translateX(-100%);\n    }\n}\n\n/* #007bff */\n.email-avatar {\n    width: 30px;\n    height: 30px;\n    \n    /* Blue background */\n    color: #e42727;\n    /* White text */\n    border-radius: 50%;\n    /* Circle shape */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    /* Adjust as needed */\n    font-weight: bold;\n    text-transform: uppercase;\n    /* Ensure letter is uppercase */\n    cursor: pointer;\n    margin-right: 10px;\n}\n.email-avatar img{\n    width:30px;\n    height:30px;\n    border-radius: 50%;\n    \n}\n\n\n\n\n@media screen and (max-width:768px){\n    .home.navbar {\n            position: fixed;\n            top: 30px;\n            left: 0;\n            width: 100vw;\n            height: 200px;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            z-index: 5;\n            opacity: 1;\n            background-color: #E42727;\n    \n    \n        }\n\n        .navbar-links{\n            display: flex;\n            flex-direction: column;\n        }\n\n        .marquee {\n            background-color: #ffcc00;\n            color: #000;\n            white-space: nowrap;\n            overflow: hidden;\n            box-sizing: border-box;\n            position: fixed;\n            top: 0;\n            width: 100vw;\n            height: 30px;\n            line-height: 30px;\n            z-index: 4;\n        }\n    \n        .marquee-content {\n            display: inline-block;\n            padding-left: 100%;\n            /* Space to enable continuous effect */\n            animation: marquee 20s linear infinite;\n        }\n    \n        .marquee-content p {\n            display: inline;\n            margin: 0;\n            font-family: 'Poppins', sans-serif;\n            color: #E42727;\n            font-weight: 400;\n            letter-spacing: 1px;\n        }\n    \n        /* Keyframes to move content continuously */\n        @keyframes marquee {\n            0% {\n                transform: translateX(0);\n            }\n    \n            100% {\n                transform: translateX(-100%);\n            }\n        }\n\n        \n}\n\n@media screen and (max-width:1000px){\n .nav-links ul li {\n        font-size: smaller;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
